import React from "react";

const SEVERIDADES = ["Alta", "Média", "Baixa"];

export function FormModal({ formSection, handle, formErrors = {} }) {
  return (
    <div>
      <div className="occ-modal__form-group">
        <label className="occ-modal__form-label">Título</label>
        <input
          type="text"
          value={formSection.titulo}
          placeholder="Ex.: Trinca na parede norte"
          onChange={e => handle(e, "titulo")}
          className={`occ-modal__form-input${formErrors.titulo ? " error" : ""}`}
        />
        {formErrors.titulo && (
          <span className="occ-modal__form-error">{formErrors.titulo}</span>
        )}
      </div>

      <div className="occ-modal__form-group">
        <label className="occ-modal__form-label">Descrição</label>
        <textarea
          rows={2}
          value={formSection.descricao}
          placeholder="Descreva a ocorrência"
          onChange={e => handle(e, "descricao")}
          className="occ-modal__form-input occ-modal__form-textarea"
        />
      </div>

      <div className="occ-modal__form-group">
        <label className="occ-modal__form-label">Ação recomendada</label>
        <textarea
          rows={3}
          value={formSection.acao}
          placeholder="Descreva a ação a ser tomada"
          onChange={e => handle(e, "acao")}
          className="occ-modal__form-input occ-modal__form-textarea"
        />
      </div>

      <div className="occ-modal__form-group">
        <label className="occ-modal__form-label">Severidade</label>
        <div className="occ-modal__severidade">
          {SEVERIDADES.map(value => (
            <label
              key={value}
              className={`occ-modal__severidade-option ${
                formSection.severidade === value ? "active" : ""
              }`}
            >
              <input
                type="radio"
                name="occ-severidade"
                value={value}
                checked={formSection.severidade === value}
                onChange={e => handle(e, "severidade")}
                className="occ-sr-only"
              />
              <span>{value}</span>
            </label>
          ))}
        </div>
        {formErrors.severidade && (
          <span className="occ-modal__form-error">{formErrors.severidade}</span>
        )}
      </div>
    </div>
  );
}
